{
  "nav.reputation": "Reviews",
  "reputation.title": "Reviews",
  "reputation.count": "{count, plural, one {# review} other {# reviews}}",
  "reputation.tabs_label": "Onderdelen van reviews",
  "reputation.tab_inbox": "Inbox",
  "reputation.tab_sources": "Bronnen",
  "reputation.tab_invitations": "Uitnodigen",
  "reputation.tab_display": "Website",
  "reputation.tab_insights": "Inzicht",
  "reputation.site_label": "Site",
  "reputation.site_all": "Alle sites",
  "reputation.action_connect": "Bron koppelen",
  "reputation.action_ask": "Review vragen",
  "reputation.not_in_plan_title": "Reviews zit niet in je pakket",
  "reputation.not_in_plan_body": "Met Reviews beantwoord je Google-reviews vanuit BRES en verzamel je geverifieerde reviews op je eigen site.",
  "reputation.not_in_plan_action": "Interesse doorgeven",
  "reputation.not_in_plan_sent": "Je interesse is doorgegeven aan BRES",
  "reputation.pro_title": "Dit hoort bij Reviews Pro",
  "reputation.pro_body": "Pro voegt alle bronnen, automatische uitnodigingen, channel managers en inzicht toe.",
  "reputation.empty_title": "Nog geen reviews gekoppeld",
  "reputation.empty_body": "Koppel je Google-profiel of nodig je klanten uit voor een review op je eigen site.",
  "reputation.empty_google_title": "Koppel je Google-profiel",
  "reputation.empty_google_body": "Je ziet al je Google-reviews hier en antwoordt vanuit BRES.",
  "reputation.empty_or": "Of begin met",
  "reputation.empty_own": "Eigen reviews op je site",
  "reputation.empty_own_meta": "Na elke verkoop of elk verblijf",
  "reputation.empty_trustpilot_meta": "Vraagt een abonnement met API-module",
  "reputation.empty_kiyoh_meta": "Voor Nederlandse en Belgische kopers",
  "reputation.empty_test_meta": "Lokale nepdienst om de koppeling te proberen",
  "reputation.empty_all": "Alle diensten",
  "reputation.empty_filtered_title": "Geen reviews met deze filters",
  "reputation.empty_filtered_body": "Pas de filters aan of wis ze om alles te zien.",
  "reputation.clear_filters": "Filters wissen",
  "reputation.summary_label": "Cijfer per bron",
  "reputation.summary_source": "{source} {value} uit {count}",
  "reputation.counter_unanswered": "{count} onbeantwoord",
  "reputation.counter_reported": "{count, plural, one {# gemeld} other {# gemeld}}",
  "reputation.counter_awaiting": "{count} wachten op publicatie",
  "reputation.counter_held": "{count} vastgehouden",
  "reputation.search_label": "Zoeken in reviews",
  "reputation.search_placeholder": "Zoek op tekst of naam",
  "reputation.filter_source": "Bron",
  "reputation.filter_source_all": "Alle bronnen",
  "reputation.filter_score": "Score",
  "reputation.filter_score_all": "Alle scores",
  "reputation.filter_status": "Status",
  "reputation.filter_status_all": "Alle statussen",
  "reputation.filter_language": "Taal",
  "reputation.filter_language_all": "Alle talen",
  "reputation.filter_period": "Periode",
  "reputation.filter_period_all": "Altijd",
  "reputation.period_7d": "Laatste 7 dagen",
  "reputation.period_30d": "Laatste 30 dagen",
  "reputation.period_90d": "Laatste 90 dagen",
  "reputation.period_365d": "Laatste jaar",
  "reputation.score_n": "{n, plural, one {# ster} other {# sterren}}",
  "reputation.col_review": "Review",
  "reputation.col_rating": "Score",
  "reputation.col_status": "Status",
  "reputation.col_received": "Ontvangen",
  "reputation.more": "Meer laden",
  "reputation.rating_label": "{value} van {scale}",
  "reputation.rating_label_count": "{value} van {scale}, {count, plural, one {# review} other {# reviews}}",
  "reputation.anonymous": "Anoniem",
  "reputation.state.unanswered": "Onbeantwoord",
  "reputation.state.answered": "Beantwoord",
  "reputation.state.awaiting_source": "Wacht op de bron",
  "reputation.state.awaiting_publication": "Wacht op publicatie",
  "reputation.state.held": "Vastgehouden",
  "reputation.state.reported": "Gemeld",
  "reputation.state.removed": "Verwijderd bij de bron",
  "reputation.state.rejected": "Niet gepubliceerd",
  "reputation.state.draft": "Concept",
  "reputation.signal_translated": "Automatisch vertaald op de site",
  "reputation.signal_verified": "Geverifieerd",
  "reputation.signal_internal": "Alleen in je beheer: deze bron staat publicatie op je site niet toe",
  "reputation.signal_screening": "Screening vond iets om te controleren",
  "reputation.signal_demo": "Voorbeeldreview (demo)",
  "reputation.signal_legacy": "Eerder gepubliceerd, niet geverifieerd",
  "reputation.sheet_title": "Review",
  "reputation.view_at": "Bekijk bij {source}",
  "reputation.verified_booking": "Geverifieerd verblijf",
  "reputation.verified_sale": "Geverifieerde aankoop",
  "reputation.verified_source": "Geverifieerd door de bron",
  "reputation.legacy_provenance": "Eerder gepubliceerd ({provenance})",
  "reputation.experience_stay": "Verblijf, {date}",
  "reputation.experience_sale": "Aankoop, {date}",
  "reputation.experience_long_let": "Verhuur, {date}",
  "reputation.experience_service": "Dienst, {date}",
  "reputation.no_text": "Alleen een score, zonder tekst.",
  "reputation.show_translation": "Vertaling tonen",
  "reputation.show_original": "Origineel tonen",
  "reputation.translation_published": "Op je site automatisch vertaald",
  "reputation.translation_withheld": "Niet gepubliceerd: de getallen in de vertaling klopten niet",
  "reputation.publish_after": "Verschijnt op je site na {when}",
  "reputation.internal_notice": "Alleen in je beheer. {source} staat publicatie op je eigen site niet toe.",
  "reputation.removed_notice": "Deze review is bij de bron verwijderd en staat niet meer op je site.",
  "reputation.reply_title": "Antwoord",
  "reputation.reply_label": "Je antwoord",
  "reputation.reply_placeholder": "Bedank, reageer op de kern en houd het kort.",
  "reputation.reply_counter": "{used} van {max}",
  "reputation.tone_label": "Toon",
  "reputation.tone_warm": "Warm",
  "reputation.tone_business": "Zakelijk",
  "reputation.tone_brief": "Kort",
  "reputation.suggest": "Antwoord voorstellen",
  "reputation.suggest_test": "Voorstel (testadapter)",
  "reputation.post_google": "Plaatsen op Google",
  "reputation.post_site": "Plaatsen op je site",
  "reputation.post_source": "Plaatsen op {source}",
  "reputation.post_shortcut": "Ctrl+Enter plaatst",
  "reputation.saved_draft": "Concept bewaard",
  "reputation.saving_draft": "Concept opslaan…",
  "reputation.posted_toast": "Antwoord geplaatst",
  "reputation.queued_toast": "Antwoord gaat naar {source}",
  "reputation.delete_reply": "Antwoord wissen",
  "reputation.delete_reply_title": "Antwoord wissen?",
  "reputation.delete_reply_body": "Het antwoord verdwijnt bij de bron en van je site.",
  "reputation.reply_state.draft": "Concept",
  "reputation.reply_state.queued": "In de wachtrij",
  "reputation.reply_state.posting": "Wordt geplaatst",
  "reputation.reply_state.pending_source": "Wacht op de bron",
  "reputation.reply_state.published": "Geplaatst",
  "reputation.reply_state.rejected_by_source": "Afgewezen door de bron",
  "reputation.reply_state.failed": "Plaatsen mislukt",
  "reputation.reply_from_source": "Antwoord van je kantoor bij de bron",
  "reputation.copy_and_open": "Kopiëren en openen bij {source}",
  "reputation.consent_missing": "Leg bij de bron eerst vast dat BRES namens je mag antwoorden.",
  "reputation.connection_not_ready": "De koppeling werkt nu niet. Antwoorden kan zodra hij hersteld is.",
  "reputation.no_reply_api": "{source} biedt geen antwoord via de API.",
  "reputation.ack_checks": "Ik heb deze punten gecontroleerd",
  "reputation.check.amount": "Je antwoord noemt een bedrag. Controleer of je dat openbaar wilt toezeggen.",
  "reputation.check.compensation": "Je antwoord belooft compensatie of korting.",
  "reputation.check.phone": "Je antwoord bevat een telefoonnummer.",
  "reputation.check.email": "Je antwoord bevat een e-mailadres.",
  "reputation.check.legal_threat": "Je antwoord bevat juridische taal.",
  "reputation.check.accusation": "Je antwoord beschuldigt de reviewer.",
  "reputation.check.booking_link": "Je antwoord verwijst naar direct boeken of een link; veel bronnen verbieden dat.",
  "reputation.check.too_long": "Je antwoord is langer dan de bron toestaat.",
  "reputation.check.test_output": "Dit is uitvoer van de testadapter. Herschrijf het voordat je plaatst.",
  "reputation.conflict_posted": "Iemand anders plaatste net een antwoord.",
  "reputation.conflict_view": "Bekijken",
  "reputation.moderation_title": "Moderatie",
  "reputation.moderation_lead": "Weigeren kan alleen met een reden uit de lijst. Dezelfde regels gelden voor elke score.",
  "reputation.reject": "Niet publiceren",
  "reputation.hold": "Vasthouden voor controle",
  "reputation.release": "Vrijgeven",
  "reputation.reject_reason": "Waarom publiceer je deze review niet?",
  "reputation.reject_note": "Toelichting voor de reviewer",
  "reputation.reject_evidence": "Bewijs dat de reviewer geen klant was",
  "reputation.reject_confirm": "Niet publiceren en reviewer informeren",
  "reputation.hold_confirm": "Vasthouden",
  "reputation.release_confirm": "Vrijgeven voor publicatie",
  "reputation.hold_note": "Wat moet er gecontroleerd worden?",
  "reputation.reason.unlawful": "Onwettige inhoud",
  "reputation.reason.abusive": "Beledigend of discriminerend",
  "reputation.reason.personal_data": "Persoonsgegevens van anderen of bijzondere persoonsgegevens",
  "reputation.reason.confidential": "Vertrouwelijke gegevens",
  "reputation.reason.spam_or_fake": "Spam of nep",
  "reputation.reason.off_topic": "Niet over de dienst",
  "reputation.reason.not_a_customer": "Geen klant (bewijs verplicht)",
  "reputation.reason.screening_contact_data": "Screening: contactgegevens in de tekst",
  "reputation.reason.screening_special_category": "Screening: mogelijk bijzondere persoonsgegevens",
  "reputation.reason.screening_third_party": "Screening: naam van een medewerker of derde",
  "reputation.reason.screening_language": "Screening: woorden om te controleren",
  "reputation.reason.moderator_check": "Controle door een moderator",
  "reputation.reason.removed_at_source": "Verwijderd bij de bron",
  "reputation.reason.reviewer_request": "Op verzoek van de reviewer",
  "reputation.reason.legal_order": "Juridisch bevel",
  "reputation.reason.disconnected": "Bron ontkoppeld",
  "reputation.reason.retention": "Bewaartermijn verstreken",
  "reputation.mark_before_change": "Markeren als van vóór een wijziging",
  "reputation.report_open": "Gemeld door een bezoeker: {reason}",
  "reputation.report_uphold": "Melding terecht",
  "reputation.report_dismiss": "Melding afwijzen",
  "reputation.report_statement": "Motivering voor de melder",
  "reputation.history_title": "Geschiedenis",
  "reputation.history.fetched": "Opgehaald bij de bron",
  "reputation.history.changed_at_source": "Gewijzigd bij de bron",
  "reputation.history.removed_at_source": "Verwijderd bij de bron",
  "reputation.history.submitted": "Ingediend via je site",
  "reputation.history.reply_saved": "Antwoord in concept",
  "reputation.history.reply_posted": "Antwoord geplaatst",
  "reputation.history.reply_deleted": "Antwoord gewist",
  "reputation.history.reported": "Gemeld door een bezoeker",
  "reputation.history.translated": "Automatisch vertaald",
  "reputation.history.published": "Gepubliceerd op de site",
  "reputation.history.purged": "Gewist na de bewaartermijn",
  "reputation.history.moderation.publish": "Gepubliceerd",
  "reputation.history.moderation.hold": "Vastgehouden",
  "reputation.history.moderation.release": "Vrijgegeven",
  "reputation.history.moderation.reject": "Niet gepubliceerd",
  "reputation.history.moderation.remove": "Verwijderd",
  "reputation.history.moderation.screened": "Gescreend",
  "reputation.history.moderation.mark_before_change": "Gemarkeerd als van vóór een wijziging",
  "reputation.history.moderation.report_resolved": "Melding afgehandeld",
  "reputation.history_by": "door {name}",
  "reputation.sources_title": "Gekoppelde bronnen",
  "reputation.sources_empty": "Nog geen bronnen gekoppeld.",
  "reputation.sources_other": "Andere diensten",
  "reputation.sources_other_lead": "Wat je nog kunt koppelen, met wat het vraagt.",
  "reputation.locations": "{count, plural, one {# locatie} other {# locaties}}",
  "reputation.last_sync": "Opgehaald {when}",
  "reputation.never_synced": "Nog niet opgehaald",
  "reputation.conn_status.awaiting_authorization": "Inloggen nodig",
  "reputation.conn_status.connected": "Gekoppeld",
  "reputation.conn_status.needs_reauth": "Opnieuw inloggen nodig",
  "reputation.conn_status.degraded": "Ophalen mislukt",
  "reputation.conn_status.paused": "Gepauzeerd",
  "reputation.conn_status.disconnected": "Ontkoppeld",
  "reputation.conn_status.error": "Fout",
  "reputation.test_source": "Testbron",
  "reputation.detail_locations": "Locaties",
  "reputation.detail_runs": "Ophaalrondes",
  "reputation.detail_evidence": "Bewijsniveau van de koppeling",
  "reputation.detail_webhook": "Webhook",
  "reputation.detail_webhook_lead": "Stel dit adres in bij de dienst. Het geheim zie je alleen nu.",
  "reputation.detail_webhook_create": "Webhookadres maken",
  "reputation.detail_webhook_url": "Adres",
  "reputation.detail_webhook_secret": "Geheim",
  "reputation.run_outcome.succeeded": "Gelukt",
  "reputation.run_outcome.partial": "Deels",
  "reputation.run_outcome.failed": "Mislukt",
  "reputation.run_outcome.skipped": "Overgeslagen",
  "reputation.run_counts": "{new} nieuw, {updated} gewijzigd, {removed} verwijderd",
  "reputation.run_trigger.schedule": "Gepland",
  "reputation.run_trigger.push": "Na een seintje",
  "reputation.run_trigger.manual": "Handmatig",
  "reputation.run_trigger.initial": "Eerste ronde",
  "reputation.run_trigger.deletions": "Verwijderingen",
  "reputation.sync_now": "Nu ophalen",
  "reputation.sync_queued": "Ophalen gestart",
  "reputation.pause": "Pauzeren",
  "reputation.resume": "Hervatten",
  "reputation.reauth": "Opnieuw inloggen",
  "reputation.disconnect": "Koppeling verbreken",
  "reputation.disconnect_title": "Koppeling met {source} verbreken?",
  "reputation.disconnect_body": "De {count} reviews van {source} verdwijnen direct van je site. BRES trekt de toegang in en wist ze binnen 7 dagen.",
  "reputation.disconnect_confirm": "Koppeling verbreken",
  "reputation.disconnected_toast": "Koppeling verbroken",
  "reputation.public_on": "Op je site",
  "reputation.public_off": "Alleen in je beheer",
  "reputation.reply_consent": "BRES mag antwoorden plaatsen die jij of je team met Plaatsen bevestigt.",
  "reputation.wizard_title": "Bron koppelen",
  "reputation.wizard_steps_label": "Stappen",
  "reputation.wizard_step_choose": "Dienst kiezen",
  "reputation.wizard_step_access": "Toegang",
  "reputation.wizard_step_locations": "Locaties",
  "reputation.wizard_step_first": "Eerste ronde",
  "reputation.wizard_search": "Zoek een dienst",
  "reputation.wizard_recommended": "Aanbevolen voor jouw kantoor",
  "reputation.wizard_all": "Alle diensten",
  "reputation.avail.direct": "Direct koppelen",
  "reputation.avail.test": "Lokale testbron, nooit een echte dienst",
  "reputation.avail.trustpilot": "Vraagt een Trustpilot-abonnement met API-module",
  "reputation.avail.internal": "Alleen in je beheer: {name} staat publicatie op je eigen site niet toe",
  "reputation.avail.airbnb_direct": "Niet direct mogelijk: Airbnb deelt reviews alleen met partners. Gebruik je Hostaway of Guesty? Koppel dan die.",
  "reputation.avail.booking_direct": "Niet direct mogelijk: Booking.com deelt reviews alleen met connectivity partners. Gebruik je Hostaway of Guesty? Koppel dan die.",
  "reputation.avail.expedia_direct": "Niet direct mogelijk: Vrbo en Expedia delen reviews alleen met connectivity providers.",
  "reputation.avail.meta_recommendations": "Gestopt: Meta biedt Facebook-aanbevelingen niet meer aan.",
  "reputation.avail.google_places": "Niet gebruikt: de Places API toont hoogstens vijf reviews en verbiedt opslag.",
  "reputation.avail.real_estate_portals": "Niet beschikbaar: vastgoedportalen bieden geen API voor makelaarsreviews.",
  "reputation.avail.widget_services": "Niet ondersteund: alleen scripts van derden, die je site trager en minder veilig maken.",
  "reputation.avail.avantio": "Nog niet beschikbaar: BRES vraagt de API-specificatie op.",
  "reputation.avail.waiting_bres": "Wacht op BRES: {missing}",
  "reputation.avail.awaiting_contract": "Vraagt eerst een akkoord van {name}",
  "reputation.avail.pro": "Reviews Pro",
  "reputation.access_oauth_lead": "BRES leest je reviews en het cijfer van de bron, en plaatst alleen antwoorden die jij bevestigt.",
  "reputation.access_login": "Inloggen bij {source}",
  "reputation.access_waiting": "Log in in het venster dat openging. Dit scherm gaat vanzelf verder.",
  "reputation.access_popup_blocked": "Het venster werd geblokkeerd. Je gaat nu via een volledige doorverwijzing.",
  "reputation.access_failed": "Inloggen is niet gelukt. Probeer het opnieuw.",
  "reputation.access_keys_lead": "Je vindt deze gegevens in je eigen account bij {source}.",
  "reputation.access_keys_help": "Waar vind ik dit?",
  "reputation.access_check": "Sleutel controleren",
  "reputation.access_ok": "Sleutel gecontroleerd en veilig opgeslagen",
  "reputation.access_rejected": "{source} accepteert deze gegevens niet. Controleer of de API-module actief is.",
  "reputation.show_secret": "Tonen",
  "reputation.hide_secret": "Verbergen",
  "reputation.locations_lead": "Kies welke locaties je koppelt en waar ze horen.",
  "reputation.locations_none": "De dienst gaf geen locaties terug.",
  "reputation.location_site": "Site",
  "reputation.location_site_none": "Niet aan een site",
  "reputation.location_property": "Woning",
  "reputation.location_property_none": "Geen woning",
  "reputation.location_public": "Tonen op je website",
  "reputation.location_public_forbidden": "Deze bron staat tonen op je website niet toe.",
  "reputation.location_link_only": "Alleen een link naar de bron",
  "reputation.first_running": "Reviews ophalen…",
  "reputation.first_done": "{count, plural, one {# review} other {# reviews}} gevonden",
  "reputation.first_done_avg": "{count, plural, one {# review} other {# reviews}} gevonden, gemiddeld {value} bij {source}",
  "reputation.first_latest": "Nieuwste reviews",
  "reputation.wizard_next": "Volgende",
  "reputation.wizard_back": "Terug",
  "reputation.wizard_finish": "Koppeling afronden",
  "reputation.wizard_save_locations": "Locaties koppelen en ophalen",
  "reputation.connected_toast": "{source} is gekoppeld",
  "reputation.consent_give": "Toestemming vastleggen",
  "reputation.consent_withdraw": "Toestemming intrekken",
  "reputation.kind.sale": "Na een aankoop",
  "reputation.kind.stay": "Na een verblijf",
  "reputation.kind.long_let": "Na een huurperiode",
  "reputation.kind.service": "Na een dienst",
  "reputation.rules_title": "Wanneer je uitnodigt",
  "reputation.rules_lead": "Iedereen met een afgeronde ervaring krijgt dezelfde uitnodiging. Er is geen filter op tevredenheid en geen beloning.",
  "reputation.rules_pro_body": "Automatisch uitnodigen hoort bij Reviews Pro. Je kunt wel per ervaring zelf een review vragen.",
  "reputation.pro_badge": "Pro",
  "reputation.rule_summary": "{days, plural, =0 {Direct na de ervaring} one {# dag na de ervaring} other {# dagen na de ervaring}}{reminder, plural, =0 {, geen herinnering} other {, herinnering na # dagen}}",
  "reputation.rule_off": "Uit: alleen handmatig uitnodigen",
  "reputation.rule_delay": "Versturen na",
  "reputation.days": "dagen",
  "reputation.rule_reminder": "Herinnering",
  "reputation.rule_reminder_none": "Geen herinnering",
  "reputation.rule_reminder_after": "Eén keer, na {days} dagen",
  "reputation.rule_destination": "Bestemming",
  "reputation.destination.bres": "Eigen reviews op je site",
  "reputation.rule_reason_title": "Waarom pas je de regel aan?",
  "reputation.rule_reason_body": "Elke wijziging komt met reden in het logboek, zodat je later kunt laten zien dat iedereen gelijk wordt uitgenodigd.",
  "reputation.rule_reason": "Reden",
  "reputation.rule_reason_placeholder": "Bijvoorbeeld: herinnering eerder, gasten reageren sneller",
  "reputation.rule_saved": "Regel opgeslagen",
  "reputation.preview_title": "Voorbeeld van de mail",
  "reputation.preview_language": "Taal",
  "reputation.preview_kind": "Soort ervaring",
  "reputation.preview_variant": "Mail",
  "reputation.preview_invite": "Uitnodiging",
  "reputation.preview_reminder": "Herinnering",
  "reputation.preview_subject": "Onderwerp:",
  "reputation.preview_frame": "Voorbeeld van de uitnodigingsmail",
  "reputation.invitations_title": "Uitnodigingen",
  "reputation.invitations_empty": "Nog geen uitnodigingen",
  "reputation.invitations_empty_body": "Leg een verkoop of verblijf vast, of importeer gasten. De uitnodiging volgt de regel hierboven.",
  "reputation.invite_all": "Alle ({count})",
  "reputation.invite_no_site": "Er is nog geen site om voor uit te nodigen",
  "reputation.col_invitee": "Klant",
  "reputation.col_when": "Moment",
  "reputation.col_expires": "Vervalt",
  "reputation.invitee_unknown": "Onbekend contact",
  "reputation.invite_when_planned": "Gepland {date}",
  "reputation.invite_when_sent": "Verstuurd {date}",
  "reputation.invite_when_submitted": "Ingediend {date}",
  "reputation.invite_status.scheduled": "Gepland",
  "reputation.invite_status.sent": "Verstuurd",
  "reputation.invite_status.reminded": "Herinnerd",
  "reputation.invite_status.submitted": "Ingediend",
  "reputation.invite_status.expired": "Verlopen",
  "reputation.invite_status.skipped": "Overgeslagen",
  "reputation.invite_status.unsubscribed": "Afgemeld",
  "reputation.invite_status.failed": "Mislukt",
  "reputation.invite_retry": "Opnieuw versturen",
  "reputation.invite_skip": "Overslaan",
  "reputation.skip_title": "{name} overslaan",
  "reputation.skip_body": "Overslaan kan alleen met een van deze redenen. Tevredenheid is geen reden.",
  "reputation.skip_reason": "Reden",
  "reputation.skip_confirm": "Overslaan",
  "reputation.skip.objection": "Bezwaar gemaakt",
  "reputation.skip.legal_dispute": "Juridisch geschil",
  "reputation.skip.deceased": "Overleden",
  "reputation.skip.no_valid_address": "Geen geldig adres",
  "reputation.skip.staff_or_owner": "Medewerker of eigenaar",
  "reputation.skip.suppressed": "Staat op de afmeldlijst",
  "reputation.skip.no_consent": "Geen toestemming (land)",
  "reputation.skip.module_off": "Module uit",
  "reputation.experience_action": "Ervaring vastleggen",
  "reputation.experience_title": "Ervaring vastleggen",
  "reputation.experience_body": "Na een verkoop of verblijf. De uitnodiging gaat volgens de regel, of direct als er geen regel aan staat.",
  "reputation.experience_contact": "Klant",
  "reputation.experience_contact_placeholder": "Zoek op naam of e-mail",
  "reputation.experience_kind": "Soort",
  "reputation.experience_date_sale": "Datum van de overdracht",
  "reputation.experience_date_stay": "Vertrekdatum",
  "reputation.experience_date_hint": "Uitnodigen kan tot 30 dagen na deze datum.",
  "reputation.experience_reference": "Referentie",
  "reputation.experience_property": "Woning",
  "reputation.experience_notice": "Medewerkers, adressen op de afmeldlijst en ontvangers zonder vereiste toestemming slaat BRES automatisch over.",
  "reputation.experience_submit": "Vastleggen",
  "reputation.experience_saved": "Ervaring vastgelegd, uitnodiging gepland",
  "reputation.import_action": "Gasten importeren",
  "reputation.import_title": "Gasten importeren",
  "reputation.import_body": "Een CSV met naam, e-mail en datum. Je ziet eerst per regel wat er gebeurt; pas daarna leg je de ervaringen vast.",
  "reputation.import_file": "CSV kiezen",
  "reputation.import_paste": "Of plak de inhoud",
  "reputation.import_column_none": "Geen kolom",
  "reputation.import_map_name": "Kolom met naam",
  "reputation.import_map_email": "Kolom met e-mail",
  "reputation.import_map_date": "Kolom met datum",
  "reputation.import_map_reference": "Kolom met referentie",
  "reputation.import_check": "Controleren",
  "reputation.import_apply": "{count, plural, one {# ervaring vastleggen} other {# ervaringen vastleggen}}",
  "reputation.import_summary": "{ok} goed, {problems} met een probleem",
  "reputation.import_ok": "Goed",
  "reputation.import_done": "{count, plural, one {# ervaring vastgelegd} other {# ervaringen vastgelegd}}",
  "reputation.import_problem.email": "Geen geldig e-mailadres",
  "reputation.import_problem.date": "Datum onleesbaar",
  "reputation.import_problem.future": "Datum in de toekomst",
  "reputation.import_problem.too_old": "Ouder dan 30 dagen",
  "reputation.import_problem.duplicate": "Dubbel in het bestand",
  "reputation.moderation_saved": "Besluit opgeslagen",
  "reputation.report_saved": "Melding afgehandeld",
  "reputation.report_confirm": "Opslaan",
  "reputation.report_external": "Een review van {source} kan alleen {source} verwijderen. Meld hem daar als hij de regels overtreedt.",
  "reputation.reject_note_hint": "De reviewer krijgt deze toelichting per mail, samen met de reden.",
  "reputation.report_reason.unlawful": "onwettig",
  "reputation.report_reason.abusive": "beledigend",
  "reputation.report_reason.personal_data": "persoonsgegevens",
  "reputation.report_reason.spam_or_fake": "spam of nep",
  "reputation.report_reason.off_topic": "niet over de dienst",
  "reputation.report_reason.other": "anders",
  "reputation.won_title": "Review vragen aan {name}?",
  "reputation.won_body": "Leg de datum van de overdracht vast. De uitnodiging gaat volgens de regel van de site, op dezelfde manier als bij iedereen.",
  "reputation.won_later": "Niet nu",
  "reputation.won_confirm": "Vastleggen",
  "reputation.won_future": "De overdracht ligt in de toekomst. Leg de ervaring vast na de overdracht.",
  "reputation.reject_published": "Van de site halen",
  "reputation.insights_empty": "Nog niets om te tonen",
  "reputation.insights_empty_body": "Zodra er reviews binnenkomen zie je hier per bron het verloop, je antwoordtijd en terugkerende thema's.",
  "reputation.insights_stats": "Kerncijfers van de laatste twaalf maanden",
  "reputation.insights_reply_rate": "Beantwoord",
  "reputation.insights_reply_rate_meta": "{answered} van {total} reviews",
  "reputation.insights_reply_time": "Antwoordtijd",
  "reputation.insights_reply_time_meta": "Mediaan, van review tot antwoord",
  "reputation.insights_hours": "{n} uur",
  "reputation.insights_days": "{n} dagen",
  "reputation.insights_invites": "Uitnodiging werd review",
  "reputation.insights_invites_meta": "{submitted} van {sent} verstuurde uitnodigingen",
  "reputation.insights_none": "Nog geen",
  "reputation.insights_monthly": "Reviews per maand, per bron",
  "reputation.insights_source_avg": "{avg} gemiddeld uit {count, plural, one {# review} other {# reviews}}",
  "reputation.insights_not_merged": "Elke bron houdt zijn eigen cijfer. BRES telt bronnen nooit samen tot één gemiddelde.",
  "reputation.insights_themes": "Terugkerende thema's",
  "reputation.insights_themes_run": "Thema's bepalen",
  "reputation.insights_themes_again": "Opnieuw bepalen",
  "reputation.insights_themes_lead": "AI leest de tekst en score van je gepubliceerde reviews (geen namen) en groepeert wat vaker terugkomt. Je ziet alleen thema's die minstens twee reviews noemen.",
  "reputation.insights_themes_test": "Bepaald door de testadapter met trefwoorden, niet door een taalmodel.",
  "reputation.insights_themes_none": "Geen thema dat in minstens twee reviews terugkomt.",
  "reputation.insights_theme_count": "{count, plural, one {# review} other {# reviews}}",
  "reputation.insights_themes_at": "Bepaald op {date}",
  "reputation.theme.communication": "Communicatie",
  "reputation.theme.guidance": "Begeleiding en uitleg",
  "reputation.theme.paperwork": "Papierwerk en notaris",
  "reputation.theme.costs": "Kosten",
  "reputation.theme.speed": "Doorlooptijd",
  "reputation.theme.after_sales": "Na de koop",
  "reputation.theme.location": "Ligging",
  "reputation.theme.cleanliness": "Schoon",
  "reputation.theme.property_condition": "Staat van de woning",
  "reputation.theme.value": "Prijs en kwaliteit",
  "reputation.sentiment.positive": "Positief",
  "reputation.sentiment.negative": "Kritisch",
  "reputation.sentiment.mixed": "Wisselend",
  "reputation.display_no_filter": "Er is geen instelling om reviews op score te filteren of later te publiceren. De selectie kiest altijd de nieuwste reviews, ongeacht de score.",
  "reputation.display_where": "Waar reviews staan",
  "reputation.display_placements": "Plekken op de site",
  "reputation.placement.home": "Homepage",
  "reputation.placement.property": "Woningpagina",
  "reputation.placement.reviews_page": "Eigen reviewpagina",
  "reputation.placement.about": "Over ons",
  "reputation.display_variant": "Uitvoering",
  "reputation.variant.light": "Licht",
  "reputation.variant.dark": "Donker",
  "reputation.variant.photo": "Over een foto",
  "reputation.display_selection": "Selectie en cijfer",
  "reputation.display_selection_lead": "De site toont de nieuwste reviews boven de minimale lengte, naast het volledige gemiddelde, de verdeling en een link naar alle reviews.",
  "reputation.display_count": "Aantal reviews in de selectie",
  "reputation.display_min_length": "Minimale lengte",
  "reputation.display_chars": "tekens",
  "reputation.display_window": "Periode voor het eigen gemiddelde",
  "reputation.display_window_all": "Alle gepubliceerde reviews",
  "reputation.display_window_months": "Laatste {months} maanden",
  "reputation.display_delay": "Wachttijd voor eigen reviews",
  "reputation.display_hours": "uur",
  "reputation.display_delay_hint": "Gelijk voor elke score. In deze tijd kun je antwoorden of een geldige reden vastleggen.",
  "reputation.display_replies": "Antwoorden van het kantoor tonen",
  "reputation.display_distribution": "Verdeling van de scores tonen",
  "reputation.display_translate": "Eigen reviews automatisch vertalen (met label en origineel)",
  "reputation.display_order": "Volgorde van de bronnen",
  "reputation.display_order_lead": "Elke bron houdt zijn eigen cijfer; de volgorde bepaalt alleen welke bron eerst staat.",
  "reputation.display_up": "{source} omhoog",
  "reputation.display_down": "{source} omlaag",
  "reputation.display_gvr": "Reviews in VacationRental-gegevens voor Google",
  "reputation.display_gvr_hint": "Alleen met een aansluiting op Google Vacation Rentals. Op makelaars- en organisatiepagina's nooit.",
  "reputation.display_preview": "Opslaan en voorbeeld bijwerken",
  "reputation.display_saved": "Weergave opgeslagen",
  "reputation.display_preview_started": "Weergave opgeslagen; het voorbeeld wordt bijgewerkt",
  "reputation.display_preview_title": "Voorbeeld van {site}",
  "reputation.display_desktop": "Desktop",
  "reputation.display_mobile": "Mobiel",
  "reputation.display_device": "Apparaat",
  "reputation.display_last_preview": "Voorbeeld versie {revision}, {date}",
  "reputation.display_no_preview": "Nog geen voorbeeld gemaakt",
  "reputation.google_lead": "Laat op je site zien wat klanten op Google over je zeggen. Gratis: BRES haalt de reviews uit je Google-bedrijfsprofiel en toont ze in de stijl van je site, met een knop om op Google een review te schrijven.",
  "reputation.google_business": "Je bedrijf op Google",
  "reputation.google_login_lead": "Log in met het Google-account waarmee je je bedrijfsprofiel beheert en kies je bedrijf. BRES leest alleen je reviews; antwoorden doe je op Google zelf.",
  "reputation.google_login": "Inloggen bij Google",
  "reputation.google_relogin": "Opnieuw inloggen",
  "reputation.google_login_failed": "Inloggen bij Google is niet gelukt",
  "reputation.google_waiting": "Rond het inloggen af in het venster van Google dat net openging.",
  "reputation.google_not_ready": "BRES rondt de koppeling met Google nog af. Tot die tijd kun je hieronder een knop naar je reviews op Google op je site zetten.",
  "reputation.google_choose": "Kies je bedrijf",
  "reputation.google_choose_lead": "De bedrijven die je met dit Google-account beheert.",
  "reputation.google_choose_none": "Dit Google-account beheert geen bedrijfsprofiel. Log in met het account waarmee je je bedrijf op Google beheert.",
  "reputation.google_use": "Dit bedrijf gebruiken",
  "reputation.google_saved": "Google-bedrijf gekoppeld. BRES haalt nu je reviews op.",
  "reputation.google_change": "Ander bedrijf",
  "reputation.google_remove": "Loskoppelen",
  "reputation.google_remove_title": "Google-reviews loskoppelen?",
  "reputation.google_remove_body": "Je site toont na de volgende publicatie geen Google-reviews meer. Gebruikt geen andere site dit Google-account, dan trekt BRES de toegang in en wist het de opgehaalde reviews binnen 7 dagen.",
  "reputation.google_sync": "Nu ophalen",
  "reputation.google_sync_started": "BRES haalt je reviews nu op",
  "reputation.google_last": "Laatst opgehaald op {when}",
  "reputation.google_first_sync": "BRES haalt je reviews voor het eerst op. Dat duurt meestal een minuut.",
  "reputation.google_schedule": "BRES haalt je reviews elke 6 uur op uit je Google-bedrijfsprofiel. Dat kost niets.",
  "reputation.google_reauth": "Google vraagt je opnieuw in te loggen. Tot dan toont je site de laatst opgehaalde reviews, hoogstens 3 dagen; daarna alleen de knop naar Google.",
  "reputation.google_error": "Het laatste ophalen lukte niet ({code}). BRES probeert het vanzelf opnieuw.",
  "reputation.google_preview": "Zo staat het op je site",
  "reputation.google_preview_note": "Uit je Google-bedrijfsprofiel, de nieuwste eerst. Je site toont er tien en laat bezoekers meer laden.",
  "reputation.google_preview_none": "Je bedrijf heeft nog geen reviews op Google. Je site toont dan alleen de knop om een review te schrijven.",
  "reputation.google_count": "{count, plural, one {# review op Google} other {# reviews op Google}}",
  "reputation.google_publish": "Op de site zetten",
  "reputation.google_published": "Publicatie gestart",
  "reputation.google_ask": "Klanten om een review vragen",
  "reputation.google_ask_lead": "Stuur deze link na een verkoop of verblijf. Hij opent direct het reviewvenster van je bedrijf op Google. Vraag het iedereen, niet alleen tevreden klanten.",
  "reputation.google_ask_copy": "Kopiëren",
  "reputation.google_links": "Alleen een knop naar Google",
  "reputation.google_links_lead": "Nog niet gekoppeld? Zet dan een knop op je site die direct het reviewvenster van je bedrijf op Google opent. Je cijfer en reviews komen er pas bij als je je bedrijf hierboven koppelt.",
  "reputation.google_links_active": "Staat op je site",
  "reputation.google_links_review": "Reviewlink van Google",
  "reputation.google_links_review_hint": "In je Google-bedrijfsprofiel: Reviews vragen, dan de link kopiëren.",
  "reputation.google_links_profile": "Link naar je bedrijf op Google Maps (optioneel)",
  "reputation.google_links_save": "Opslaan",
  "reputation.google_links_saved": "Knop naar Google opgeslagen",
  "reputation.google_links_remove": "Verwijderen"
}
